/**
 * Voorzieningen Tour
 *
 * Walkthrough for the asset categories configuration page.
 * Shows users how to set up categories and types for building assets.
 */

import { TourDefinition } from '../config/tourSteps';

export const voorzieningenTour: TourDefinition = {
  id: 'voorzieningenTour',
  steps: [
    {
      element: '[data-tour="asset-categories-list"]',
      popover: {
        title: 'Voorzieningen Categorieën',
        description:
          'Hier beheert u de hoofdcategorieën voor voorzieningen: CV & Verwarming, Liften, Branddetectie, Elektra, etc. Elke categorie bevat specifieke types.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="asset-types-list"]',
      popover: {
        title: 'Types per Categorie',
        description:
          'Binnen elke categorie kunt u types definiëren. Bijvoorbeeld: binnen "CV & Verwarming" kunt u types hebben zoals CV-ketel, Warmtepomp, Boiler, etc.',
        side: 'right',
        align: 'start',
      },
    },
    {
      element: '[data-tour="custom-fields"]',
      popover: {
        title: 'Aangepaste Velden',
        description:
          'Definieer per type welke velden u wilt vastleggen. Bijvoorbeeld: voor CV-ketels kunt u velden toevoegen zoals Vermogen, Merk, Bouwjaar, Certificaatnummer.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: '[data-tour="required-documents"]',
      popover: {
        title: 'Verplichte Documenten',
        description:
          'Geef aan welke documenten verplicht zijn voor dit type voorziening. Bijvoorbeeld: voor liften zijn keuringsrapporten en onderhoudcontracten verplicht.',
        side: 'left',
        align: 'center',
      },
    },
  ],
};
